(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features"] && !Shopify.designMode) return;
  try {
    
  function initHowItWorksAccordion() {
    document.querySelectorAll('.features-section').forEach((section) => {
      const items = section.querySelectorAll('.features-item');
      const tabImgsLeft = section.querySelectorAll('.features-tab-img-left');
      const tabImgsRight = section.querySelectorAll('.features-tab-img-right');

      items.forEach((item, idx) => {
        const btn = item.querySelector('.features-tab-btn');
        const pane = item.querySelector('.features-tab-pane');
        const icon = btn.querySelector('.htw-icon');

        btn.addEventListener('click', () => {
          const isOpen = pane.classList.contains('active');

          if (isOpen) {
            pane.classList.remove('active');
            pane.style.maxHeight = '0px';
            btn.classList.remove('active');
            icon.innerHTML = '+';
            tabImgsLeft[idx]?.classList.remove('active');
            tabImgsRight[idx]?.classList.remove('active');

            const anyOpen = [...items].some((t) => t.querySelector('.features-tab-pane').classList.contains('active'));

            if (!anyOpen) {
              const nextIndex = idx + 1 < items.length ? idx + 1 : 0;
              const nextItem = items[nextIndex];
              const nextBtn = nextItem.querySelector('.features-tab-btn');
              nextBtn.click();
            }
            return;
          }

          items.forEach((it, i) => {
            const itPane = it.querySelector('.features-tab-pane');
            const itBtn = it.querySelector('.features-tab-btn');
            const itIcon = itBtn.querySelector('.htw-icon');
            itPane.classList.remove('active');
            itPane.style.maxHeight = '0px';
            itBtn.classList.remove('active');
            itIcon.innerHTML = '+';
            tabImgsLeft[i]?.classList.remove('active');
            tabImgsRight[i]?.classList.remove('active');
          });

          requestAnimationFrame(() => {
            btn.classList.add('active');
            pane.classList.add('active');
            const height = pane.scrollHeight;
            pane.style.maxHeight = height + 'px';
            icon.innerHTML = '–';
            tabImgsLeft[idx]?.classList.add('active');
            tabImgsRight[idx]?.classList.add('active');
          });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initHowItWorksAccordion);
  document.addEventListener('shopify:section:load', initHowItWorksAccordion);

  } catch(e) { console.error(e); }
})();
})();
